import { Component, OnInit } from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {statesDropdown} from "../../../shared/StatesUS";
import {ClientService} from "../../../Services/client.service";
import {PayerService} from "../../../Services/payer.service";
import {AuthService} from "../../../auth/AuthService";
import {ActivatedRoute, Router} from "@angular/router";
import {first} from "rxjs/operators";
import swal from "sweetalert2";

@Component({
  selector: 'pm-add-header',
  templateUrl: './add-header.component.html',
  styleUrls: ['./add-header.component.css']
})
export class AddHeaderComponent implements OnInit {
  headerForm!: FormGroup;
  PayerId: any;
  status: boolean = false;
  clientList: any = [];
  stateList: any = statesDropdown;

  constructor(private fb: FormBuilder,
              private clientServices: ClientService,
              private payerService: PayerService,
              private authService: AuthService,
              private activatedRoute: ActivatedRoute,
              private route: Router) {

    this.PayerId = this.activatedRoute.snapshot.paramMap.get('id');

    this.headerForm = this.fb.group({
      name: [null, Validators.required],
      payerIdCode: [null, Validators.required],
    });

    if (this.PayerId) {
      let reqData: any = {
        id: this.PayerId
      };
      this.payerService.getPayerDetails(reqData).pipe(first()).subscribe(
        (response: any) => {
          if (response != undefined) {
            let data = response;
            this.status = data.active ? data.active : false;
            this.headerForm.patchValue({
              id: data.id,
              name: data?.name ? data.name : null,
              payerIdCode: data?.payerIdCode ? data.payerIdCode : null,
            });
          } else {
            swal.fire({
              title: 'Error!',
              icon: 'error',
              text: response.message,
              showConfirmButton: false,
              timer: 5000
            });
          }
        },
        (error) => {
          swal.fire({
            title: 'Error!',
            icon: 'error',
            text: error.error.message,
            showConfirmButton: false,
            timer: 5000
          });
        }
      );
    }
  }


  ngOnInit(): void {
    this.headerForm = this.fb.group({
      headers: this.fb.array([this.createHeader()])
    });
  }
  // Change status
  changeStatus(status: any) {
    if (status == true) {
      this.status = false;
    } else {
      this.status = true;
    }
  }
  // Create one header form control
  createHeader(): FormGroup {
    return this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]]
    });
  }

  // Get headers form array
  get headers(): FormArray {
    return this.headerForm.get('headers') as FormArray;
  }

  // Add new header field
  addHeader(): void {
    this.headers.push(this.createHeader());
  }

  // Remove header field
  removeHeader(index: number): void {
    this.headers.removeAt(index);
  }
  // Register client function / update
  onRegister(): any {
    this.headerForm.markAllAsTouched();
    if (this.headerForm.valid) {
      let reqData = {
        name: this.headerForm.controls.name.value ? this.headerForm.controls.name.value : null,
        payerIdCode: this.headerForm.controls.payerIdCode.value ? this.headerForm.controls.payerIdCode.value : null,
      };

      // update logic
      if (this.PayerId) {
        let params = {
          id: this.PayerId,
        };
        this.payerService.updatePayer(reqData, params).pipe(first()).subscribe(
          (response: any) => {
            if (response != undefined) {
              this.route.navigate(['payer']);
              swal.fire({
                icon: 'success',
                text: 'Payer :- ' + `" ${reqData.name} "` + ' updated successfully.',
                showConfirmButton: false,
                timer: 3000
              });
            } else {
              swal.fire({
                title: 'Error!',
                icon: 'error',
                text: response.message,
                showConfirmButton: false,
                timer: 5000
              });
            }
          },
          (error) => {
            swal.fire({
              title: 'Error!',
              icon: 'error',
              text: error.error.message,
              showConfirmButton: false,
              timer: 5000
            });
          }
        );
      }
      // add / register logic
      else {
        this.payerService.addPayer(reqData).pipe(first()).subscribe(
          (response: any) => {
            if (response != undefined) {
              this.route.navigate(['payer']);
              swal.fire({
                icon: 'success',
                text: 'Payer :- ' + `" ${reqData.name} "` + ' registered successfully.',
                showConfirmButton: false,
                timer: 3000
              });
            } else {
              swal.fire({
                title: 'Error!',
                icon: 'error',
                text: response.message,
                showConfirmButton: false,
                timer: 5000
              });
            }
          },
          (error) => {
            swal.fire({
              title: 'Error!',
              icon: 'error',
              text: error.error.message,
              showConfirmButton: false,
              timer: 5000
            });
          }
        );
      }

    }
  }

}
